import React, { useRef } from "react";
import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../components/Loader";

import InputLabel from "@mui/material/InputLabel";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
// import AddEmployee from "./AddEmployee";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

export default function AddLocation() {
  const [open, setOpen] = useState(false);
  const [state, setstate] = useState("");
  const [stateData, setstateData] = useState([]);
  const [location, setLocation] = React.useState({
    hrcCsm: "",
    csmManager: "",
    locationClass: "",
    status: "",
  });
  const [data, setData] = useState([]);
  const [showdata, setshowData] = useState(false);

  const [locationdaata, setlocationdaata] = useState([]);
  const [employeeName, setemployeeName] = useState({
    associate: [],
    manager: [],
  });
  const [employeeNameData, setemployeeNameData] = useState({
    associate: null,
    manager: null,
  });

  const { globalFilter, pageIndex, pageSize } = state;

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },
      {
        Header: "Name",

        accessor: "name",
      },
      {
        Header: "City",

        accessor: "city",
      },
      {
        Header: "Contact No.",

        accessor: "contact",
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    // state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const resetValues = useRef(null);
  const nextPageRef = useRef(null);

  const resetter = () => {
    resetValues?.current?.click();
  };
  const nextPageReference = () => {
    nextPageRef?.current.click();
  };

  const allLocations = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/location/getAllLocations`
      );

      if (res.data.responseStatus.statusCode == 200) {
        // setData(res.data.response.locations);
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const validationSchema = yup.object({
    city: yup
      .string("Enter your City")
      .min(2, "City should be of minimum 2 characters length")
      .required("City is required"),
    name: yup
      .string("Enter your Name")
      .min(2, "Name should be of minimum 2 characters length")
      .required("Name is required"),

    contact: yup
      .number("Enter your PhoneNumber")
      .min(1000000000, "PhoneNumber should be of minimum 10 characters length")
      .max(
        100000000000,
        "PhoneNumber should be of maximum 11 characters length"
      )
      .required("PhoneNumber is required"),
  });

  const locationClassId = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/master/getAllLocationClasses`
      );

      // console.log(res.data);
      if (res.data.responseStatus.statusCode == 200) {
        setOpen(false);
        setlocationdaata(res.data.locationClassMaster);
      } else {
        setTimeout(async () => {
          await toast.error(res.data.responseStatus.statusDescription);
        }, 100);
      }
    } catch (error) {
      console.log(error);
      setTimeout(async () => {
        await toast.error("Something Went Wrong ! Please check your Network");
      }, 100);
    }
  };
  const states = async () => {
    try {
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/master/getAllStates`
      );

      // console.log(res.data);
      if (res.data.responseStatus.statusCode == 200) {
        setstateData(res.data.stateMaster);
      } else {
        setTimeout(async () => {
          await toast.error(res.data.responseStatus.statusDescription);
        }, 100);
      }
    } catch (error) {
      console.log(error);
      setTimeout(async () => {
        await toast.error("Something Went Wrong ! Please check your Network");
      }, 100);
    }
  };

  // const employees = async () => {
  //   try {
  //     const res = await axios(
  //       `${process.env.REACT_APP_COMMON_API}/employee/getAllEmployees`
  //     );

  //     console.log(res.data);
  //     if (res.data.responseStatus.statusCode == 200) {
  //       const ids = res.data.employeeResponse.map((o) => o.employeename);
  //       const filtered = res.data.employeeResponse.filter(
  //         ({ employeename }, index) => !ids.includes(employeename, index + 1)
  //       );
  //       setemployeeName({
  //         associate: filtered,
  //         manager: filtered,
  //       });
  //     } else {
  //       setTimeout(async () => {
  //         await toast.error(res.data.responseStatus.statusDescription);
  //       }, 100);
  //     }
  //   } catch (error) {
  //     setTimeout(async () => {
  //       await toast.error("Something went wrong ! Please check your network");
  //     }, 100);
  //   }
  // };

  useEffect(() => {
    states();
    locationClassId();
    // employees();
  }, []);

  const formik = useFormik({
    initialValues: {
      city: "",
      contact: "",

      state: "",

      name: "",
      hrcCsm: "",
      csmManager: "",
      locationClass: "",
      status: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/location/addLocation`,
          {
            locationPrimaryEntity: {
              name: values.name,
              city: values.city,
              stateid: state,
              contact: values.contact,
            },
            locationSecondaryEntity: {
              associatehrcsmuserid: employeeNameData.associate.userid,
              csmmanageruserid: employeeNameData.manager.userid,
              locationclassid: location.locationClass,
              currentstatus: location.status,
            },
          }
        );
        if (res.data.statusCode == 200) {
          setOpen(false);

          await formik.handleReset();
          await resetter();
          await setshowData(true);

          await allLocations();

          await setTimeout(async () => {
            await toast.success("Location Created SuccessFully", {
              theme: "colored",
            });
          }, 100);
        } else {
          setOpen(false);
          await setTimeout(async () => {
            await toast.error(res.data.statusDescription.description, {
              theme: "colored",
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        await setTimeout(async () => {
          await toast.error("Something went wrong", {
            theme: "colored",
          });
        }, 100);
      }
    },
  });

  return (
    <>
      {" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <div class="container-fluid">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 ms_5">
                <p>Add Location</p>
                <p class="text-sm mb-0 text-capitalize fw-bold">
                  Fields mark with!!
                  <span class="text-danger fw-bold">*</span> are mandatory.
                </p>
              </div>
            </div>
            {/* <ul class="nav nav-tabs ms-4 mt-4" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home"
                  type="button"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  Add Location
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  disabled={getButtonAdd}
                  ref={nextPageRef}
                  // value={tabToggle}
                  class="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile"
                  type="button"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  Add Employee
                </button>
              </li>
            </ul> */}
            <div class="card-body p-4 mt-5 tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <form onSubmit={formik.handleSubmit} class="m-0">
                  <div class="card card_8 d-block">
                    <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                      <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                      <span class="d-block w-100 text-uppercase ms-2">
                        new location form
                      </span>
                    </div>
                    <div class="card-body">
                      <ThemeProvider theme={theme}>
                        <div className="formisform">
                          <div class="row">
                            <div className="col-md-3">
                              <TextField
                                required
                                className="w-100"
                                label="Name"
                                name="name"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.name &&
                                  Boolean(formik.errors.name)
                                }
                                helperText={
                                  formik.touched.name && formik.errors.name
                                }
                              />
                            </div>
                            <div className="col-md-3">
                              <TextField
                                required
                                className="w-100"
                                label="City"
                                name="city"
                                variant="outlined"
                                size="small"
                                type="text"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.city &&
                                  Boolean(formik.errors.city)
                                }
                                helperText={
                                  formik.touched.city && formik.errors.city
                                }
                              />
                            </div>
                            <div className="col-md-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  State
                                </InputLabel>
                                <Select
                                  size="small"
                                  required
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={state}
                                  label="State"
                                  onChange={(e) => {
                                    setstate(e.target.value);
                                  }}
                                >
                                  {stateData?.map((e) => {
                                    return (
                                      <MenuItem value={e?.stateid}>
                                        {e?.state}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <div className="col-md-3">
                              <TextField
                                required
                                className="w-100"
                                label="Contact No."
                                name="contact"
                                variant="outlined"
                                size="small"
                                type="number"
                                value={formik.values.contact}
                                onChange={formik.handleChange}
                                error={
                                  formik.touched.contact &&
                                  Boolean(formik.errors.contact)
                                }
                                helperText={
                                  formik.touched.contact &&
                                  formik.errors.contact
                                }
                                onInput={(e) => {
                                  e.target.value = Math.max(
                                    0,
                                    parseInt(e.target.value)
                                  )
                                    .toString()
                                    .slice(0, 10);
                                }}
                              />
                            </div>
                          </div>
                          <div class="row mt-4">
                            <div className="col-md-3">
                              {/* <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Associate HRM-CSM
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.hrcCsm}
                              label="Associate HRM-CSM"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  hrcCsm: e.target.value,
                                });
                              }}
                            >
                              <MenuItem value={10}>ererer</MenuItem>
                              <MenuItem value={20}>Twqasdazsdenty</MenuItem>
                              <MenuItem value={30}>Thirwrewqrafty</MenuItem>
                            </Select>
                          </FormControl> */}
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employeeName.associate}
                                getOptionLabel={(option) =>
                                  `${option.employeename}`
                                }
                                value={employeeNameData.associate}
                                onChange={(e, val) => {
                                  setemployeeNameData({
                                    ...employeeNameData,
                                    associate: val,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="Associate-HRM"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-md-3">
                              {/* <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              CSM-Manager
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.csmManager}
                              label="CSM-Manager"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  csmManager: e.target.value,
                                });
                              }}
                            >
                              <MenuItem value={10}>asfaef</MenuItem>
                              <MenuItem value={20}>Tweaweawaenty</MenuItem>
                              <MenuItem value={30}>Thiradty</MenuItem>
                            </Select>
                          </FormControl> */}
                              <Autocomplete
                                fullWidth
                                required
                                size="small"
                                disablePortal
                                id="combo-box-demo"
                                options={employeeName.manager}
                                getOptionLabel={(option) =>
                                  `${option.employeename}`
                                }
                                value={employeeNameData.manager}
                                onChange={(e, val) => {
                                  setemployeeNameData({
                                    ...employeeNameData,
                                    manager: val,
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    size="small"
                                    label="CSM-Manager"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-md-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Location Class
                                </InputLabel>
                                <Select
                                  size="small"
                                  required
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={location.locationClass}
                                  label="Location Class"
                                  onChange={(e) => {
                                    setLocation({
                                      ...location,
                                      locationClass: e.target.value,
                                    });
                                  }}
                                >
                                  {locationdaata?.map((lo) => {
                                    // console.log(lo);
                                    return (
                                      <MenuItem
                                        value={lo.locationclassificationid}
                                      >
                                        {lo.locationclassification}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                            <div className="col-md-3">
                              <FormControl required fullWidth>
                                <InputLabel
                                  size="small"
                                  id="demo-simple-select-label"
                                >
                                  Status
                                </InputLabel>
                                <Select
                                  size="small"
                                  required
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={location.status}
                                  label="Status"
                                  onChange={(e) => {
                                    setLocation({
                                      ...location,
                                      status: e.target.value,
                                    });
                                  }}
                                >
                                  <MenuItem value="true">Working</MenuItem>
                                  <MenuItem value="False">Not-Working</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      </ThemeProvider>
                      <div class="text-end my-4">
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{ background: "#F67503" }}
                          endIcon={<SendIcon />}
                        >
                          Submit
                        </Button>
                        <Button
                          ref={resetValues}
                          onClick={() => {
                            formik.handleReset();
                            setLocation({
                              hrcCsm: "",
                              csmManager: "",
                              locationClass: "",
                              status: "",
                            });
                            setstate("");
                            setemployeeNameData({
                              associate: null,
                              manager: null,
                            });
                          }}
                          sx={{ marginLeft: "10px", background: "#4C4234" }}
                          type="reset"
                          variant="contained"
                          endIcon={<RestartAltIcon />}
                        >
                          Reset
                        </Button>
                      </div>
                      <div className="text-end">
                        <p> List of Locations </p>
                        <Link className="primary" to="/dashboard/ViewLocations">
                          <p style={{ color: "#F47C03" }}>Click here !!</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* {showdata ? (
        <div className="card mb-3 mt-4">
          <div class="card-header p-3 position-relative border-0 bg-white">
            <div class="ttl_bx position-absolute d-flex mt_n4">
              <i class="fas fa-user d-block m-auto"></i>
            </div>
            <div class="d-flex justify-content-between title_8 ms_5">
              <p>Recently Added</p>
          
            </div>
          </div>

          {data.length > 0 ? (
            <div className="card-body p-4 mt-5">
            

              <table
                {...getTableProps()}
                id="example"
                className="table table-striped table-bordered dataTable table-sm mt-3"
                style={{ width: "100%" }}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          className="text-center width_2"
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? "↑"
                                : "↓"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="text-center"
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="d-flex justify-content-between">
               

                <div>
              
                </div>

                <div id="Nikhil">
                  <button
                    className="btn btn_primary m-0 ms-2"
                    type="button"
                    style={{
                      background: "#2C97D4",
                    }}
                    disabled={!canPreviousPage}
                    onClick={() => {
                      previousPage();
                    }}
                  >
                    Prev
                  </button>

                  <button
                    className="btn btn_primary m-0 ms-2"
                    type="button"
                    style={{
                      background: "#2C97D4",
                    }}
                    disabled={!canNextPage}
                    onClick={() => {
                      nextPage();
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body">
              <div>
                <h5
                
                  style={{ textAlign: "center" }}
                >
                  No Data Available
                </h5>
              </div>
            </div>
          )}

    
        </div>
      ) : null} */}
    </>
  );
}
